import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import * as loginSelectors from './../../../../../root-store/login-store/login.selector';

import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';
@AutoUnsubscribe()
@Component({
  selector: 'instructions_uploads_one',
  templateUrl: './instructions_uploads_one.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DiscoveryInstructionsUploadsOneComponent implements OnInit, OnDestroy {
  @Input() data;
  @Output() moveNextPreviousEvent = new EventEmitter<any>();

  mainTitle;
  subscription = new Subscription();
  instructions = [
    {
      title: 'Upload digital items',
      imageNumber: '8',
      instructionLists: [
        'Upload the items that you collected a <span class="font-bold"> digital copy </span> of first.',
        'If nothing was collected as a digital copy, you may skip this step.',
      ],
    },
    {
      title: 'Select the physical copies your want to add',
      imageNumber: '9',
      instructionLists: [
        'Select the items which were gathered as <span class="font-bold"> physical copies </span> which that you would like to upload into Kinnect with your mobile device.',
      ],
    },
    {
      title: 'Download your selections (if necessary)',
      imageNumber: '1',
      instructionLists: [
        'If there are a large number of items to photo, it might be beneficial <span class="font-bold"> to download a copy of the list of your selections </span> before the next step. ',
      ],
    },
  ];

  constructor(private store: Store) {
    this.subscription.add(
      this.store.select(loginSelectors.getCurrentUserDetailsAll).subscribe((user) => {
        this.mainTitle = `<span class="font-bold text-[#25508E]"> Start uploading items </span> into ${user?.first_name}’s account`;
      })
    );
  }

  ngOnInit(): void {}

  instructionBackOrForwardEvent(event) {
    this.moveNextPreviousEvent.emit({ status: event?.status, ...(event.status == 'forward' && { id: this.data?.id }) });
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }
}
